import React from "react";
import { Whisper, Tooltip } from "rsuite";
import InfoRoundIcon from '@rsuite/icons/InfoRound'

const InfoIcon = ({ text }) => {
  return (
    <Whisper trigger={(['hover', 'click'])} speaker={<Tooltip>{text}</Tooltip>}>
      <InfoRoundIcon style={{ cursor: 'pointer' }} />
    </Whisper>
  );
};

export default InfoIcon;
